/* eslint-disable import/prefer-default-export */
import icon from '../assets/labbuild-favicon.png';

export const labbuildConfig = {
  title: 'LabBuild',
  catalog: 'partner',
  partner: 'labbuild',
  origin: 'https://labbuild.com/',
  host: 'seating.labbuild.com',
  logo: 'https://ecomseating.s3.amazonaws.com/images/other/labbuild-logo-bright.png',
  logoURL: 'https://ecomseating.s3.amazonaws.com/images/other/labbuild-logo.png',
  phone: '720-798-1983',
  buildAChair: 'labbuild',
  businessInfo: 'LabBuild, LLC, 1942 Broadway Ste 314C, Boulder, CO, 80302, US',
  headerTheme: '#252525',
  secondaryTheme: '#F1C40F',
  footerTheme: '#252525',
  headerTextColor: '#FFFFFF',
  footerTextColor: '#FFFFFF',
  buttonTextColor: '#000000',
  extraAttributes: {
    trackId: 'G-4HT2VC9N88',
    icon,
  },
};
